import React from 'react'

const Manifest = () => {
  return (
    <div>Manifest</div>
  )
}

export default Manifest